import { call, put, takeLatest } from 'redux-saga/effects';
import ConfigDal from '../../../dal/ConfigDal';
import {
    getFeatureFlagsData,
    getFeatureFlagsDataRequest,
    getFeatureFlagsDataSuccess,
    getFeatureFlagsDataFail,
} from '../../../store/config/configReducer';

function* fetchFeatureFlags(): IterableIterator<any> {
    try {
        yield put(getFeatureFlagsDataRequest());
        const response = yield call(ConfigDal.getFeatureFlags);
        yield put(getFeatureFlagsDataSuccess(response));
    } catch (e) {
        yield put(getFeatureFlagsDataFail(e));
    }
}

export default [
    takeLatest(`${getFeatureFlagsData}`, fetchFeatureFlags),
];